var map = {
	"./black/amorsaude.svg": "7fa3",
	"./black/cna.svg": "38ae",
	"./black/drogariasp.svg": "add4",
	"./black/drogasil.svg": "b8a0",
	"./black/estacio.svg": "5765",
	"./black/paguemenos.svg": "8514",
	"./black/preparatodos.svg": "2346",
	"./black/raia.svg": "6d31",
	"./black/refuturiza.svg": "c59d",
	"./blue/amorsaude.svg": "ff98",
	"./blue/cna.svg": "bb72",
	"./blue/drogariasp.svg": "1fea",
	"./blue/estacio.svg": "97d2",
	"./blue/paguemenos.svg": "447b",
	"./blue/preparatodos.svg": "da04",
	"./white/amorsaude.svg": "e4e7",
	"./white/cna.svg": "f808",
	"./white/drogariasp.svg": "39af",
	"./white/drogasil.svg": "bf88",
	"./white/estacio.svg": "71c4",
	"./white/paguemenos.svg": "cac7",
	"./white/preparatodos.svg": "ae7d",
	"./white/raia.svg": "2093",
	"./white/refuturiza.svg": "17da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d16";